/* GUAPI SUMMER SALE 2026 - tier navigation v4.22 (draft theme).
   v4.22: scarcity label shortened ('N SIZES LEFT') so both badges share the
   top row with a clean gap on mobile. */
(function(){
  var PAGES = { '/collections/summer-sale': 'all', '/collections/sale-75': '75', '/collections/sale-50': '50', '/collections/sale-25': '25' };
  var HERO = 'https://cdn.shopify.com/s/files/1/1800/4445/files/GUAPI1206268947.png?v=1786646357';
  var here = location.pathname.replace(/\/$/, '');
  if (here.indexOf('/collections/') !== 0) return;
  var cur = PAGES[here];
  var qs = location.search || '';
  var GPM_KEY = new URLSearchParams(location.search).get('gpm');
  var INFO = {};
  var MARGIN = null;
  var HEALED = false;
  function fmt(n){ return '$ ' + n.toFixed(2) + ' USD'; }
  function pill(href, label, on){
    return '<a href="'+href+qs+'"'+(on ? ' class="on"' : '')+'>'+label+'</a>';
  }
  function hideChrome(){
    if (!cur) return;
    document.querySelectorAll('facet-filters-form, .facets__product-count, .collection-facets__status, .active-facets, #ProductCount, .collection-facets__item').forEach(function(e){
      if (e.querySelector && e.querySelector('a[href*="/products/"]')) return;
      e.style.display = 'none';
    });
  }
  function healGrid(){
    if (HEALED) return;
    var grid = document.getElementById('product-grid');
    if (!grid || grid.querySelectorAll('.guapi-qs-card').length > 0) return;
    var sid = grid.getAttribute('data-id');
    if (!sid) return;
    HEALED = true;
    fetch(location.pathname + '?section_id=' + encodeURIComponent(sid) + '&gpx=' + Date.now(), {cache:'no-store'})
      .then(function(r){ return r.text(); })
      .then(function(t){
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var g2 = doc.getElementById('product-grid');
        if (g2 && g2.querySelectorAll('.guapi-qs-card').length > 0) {
          grid.innerHTML = g2.innerHTML;
          hideChrome();
          decorate();
        }
      }).catch(function(){});
  }
  function loadMargin(){
    if (!GPM_KEY) return;
    fetch('https://guapi-pnl.guapi-ops.workers.dev/margindata?key=' + encodeURIComponent(GPM_KEY))
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){ if (d && typeof d === 'object') { MARGIN = d; decorate(); } })
      .catch(function(){});
  }
  function loadInfo(cb){
    fetch(here + '/products.json?limit=250&_gp=' + Date.now(), {cache:'no-store'}).then(function(r){return r.json()}).then(function(d){
      (d.products||[]).forEach(function(p){
        var vs = p.variants || [];
        var tags = (p.tags || []).map(function(t){return String(t).toLowerCase();});
        var pct = tags.indexOf('sale-75') > -1 ? 75 : tags.indexOf('sale-50') > -1 ? 50 : tags.indexOf('sale-25') > -1 ? 25 : 0;
        var oneSize = vs.length === 1 && /^default title$/i.test(vs[0].title || '');
        var sizes = 0;
        var seen = {};
        vs.forEach(function(v){ if (v.available && !seen[v.title]) { seen[v.title] = 1; sizes++; } });
        if (oneSize) sizes = 99;
        var v0 = null;
        for (var i=0;i<vs.length;i++){ if (vs[i].available) { v0 = vs[i]; break; } }
        var save = 0, orig = 0, sim = 0;
        if (v0) {
          var price = parseFloat(v0.price);
          var cmp = v0.compare_at_price ? parseFloat(v0.compare_at_price) : 0;
          if (cmp > price) { save = Math.round(cmp - price); }
          else if (pct > 0) { orig = price; sim = Math.round(price * (1 - pct/100) * 2) / 2; save = Math.round(orig - sim); }
        }
        INFO[p.handle] = { sizes: sizes, save: save, orig: orig, sim: sim };
      });
      cb();
    }).catch(function(e){ cb(); });
  }
  function simPrice(card, info){
    if (!info.sim || card.getAttribute('data-gp-sim')) return;
    var priceBox = card.querySelector('.guapi-qs-card-price');
    if (!priceBox) return;
    var moneys = priceBox.querySelectorAll('.money');
    if (!moneys.length) return;
    card.setAttribute('data-gp-sim', '1');
    moneys[0].textContent = fmt(info.sim);
    if (!priceBox.querySelector('.guapi-qs-compare')) {
      var c = document.createElement('span');
      c.className = 'guapi-qs-compare';
      c.innerHTML = '<span class="money">' + fmt(info.orig) + '</span>';
      priceBox.appendChild(c);
    }
  }
  function marginStrip(card, handle){
    if (!MARGIN || card.querySelector('.gp-mg')) return;
    var m = MARGIN[handle];
    if (!m) return;
    var body = card.querySelector('.guapi-qs-card-body') || card;
    var s = document.createElement('div');
    var cls = m.v === 'L' ? 'loss' : m.v === 'B' ? 'be' : m.v === 'X' ? 'miss' : 'prof';
    s.className = 'gp-mg gp-mg-' + cls;
    if (m.v === 'X') {
      s.textContent = 'COST MISSING \u00b7 ' + m.s + ' units';
    } else {
      var lbl = m.v === 'L' ? 'LOSS' : m.v === 'B' ? 'BREAK-EVEN' : 'PROFIT';
      s.textContent = 'COST $' + m.c + ' \u00b7 NET ' + (m.n < 0 ? '\u2212$' + Math.abs(m.n) : '+$' + m.n) + '/unit \u00b7 ' + m.s + ' units \u00b7 ' + lbl;
    }
    body.appendChild(s);
  }
  function decorate(){
    document.querySelectorAll('main a[href*="/products/"]').forEach(function(a){
      try {
        var m = (a.getAttribute('href')||'').match(/\/products\/([a-z0-9\-]+)/);
        if (!m || !INFO[m[1]]) return;
        var info = INFO[m[1]];
        var card = a.closest('.guapi-qs-card') || a.closest('li') || a.closest('.card-wrapper');
        if (!card || card.closest('#gp-tier-nav')) return;
        if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
        simPrice(card, info);
        marginStrip(card, m[1]);
        if (info.sizes > 0 && info.sizes <= 3 && !card.querySelector('.gp-scarce')) {
          var b = document.createElement('span');
          b.className = 'gp-scarce';
          b.textContent = info.sizes === 1 ? 'LAST SIZE' : info.sizes + ' SIZES LEFT';
          card.appendChild(b);
        }
        if (info.save > 0 && !card.querySelector('.gp-save')) {
          var s = document.createElement('span');
          s.className = 'gp-save';
          s.textContent = 'SAVE $' + info.save;
          card.appendChild(s);
        }
      } catch(e){}
    });
  }
  function clean(){
    document.querySelectorAll('.guapi-qs-card-track .gp-scarce, .guapi-qs-card-track .gp-save, .guapi-qs-card-gallery > .gp-scarce, .guapi-qs-card-gallery > .gp-save').forEach(function(e){ e.remove(); });
  }
  function mount(){
    var main = document.querySelector('main');
    if (!main) return false;
    document.body.classList.add('gp-anysale');
    if (cur && !document.getElementById('gp-tier-nav')) {
      document.body.classList.add('gp-sale-page');
      var nav = document.createElement('nav');
      nav.id = 'gp-tier-nav';
      nav.innerHTML =
        pill('/collections/summer-sale', 'ALL SALE', cur === 'all')+
        pill('/collections/sale-75', '75% OFF', cur === '75')+
        pill('/collections/sale-50', '50% OFF', cur === '50')+
        pill('/collections/sale-25', '25% OFF', cur === '25');
      main.insertBefore(nav, main.firstChild);
      if (cur === 'all' && !document.getElementById('gp-sale-hero')) {
        var hero = document.createElement('div');
        hero.id = 'gp-sale-hero';
        hero.innerHTML = '<img src="'+HERO+'" alt="GUAPI Summer Sale" fetchpriority="high">';
        main.insertBefore(hero, nav);
      }
    }
    hideChrome();
    loadInfo(function(){
      clean();
      decorate();
      loadMargin();
      [900, 2000, 3400, 5200].forEach(function(t){ setTimeout(function(){ hideChrome(); clean(); decorate(); }, t); });
      setTimeout(healGrid, 4500);
      setTimeout(healGrid, 8000);
      new MutationObserver(function(){ clean(); decorate(); }).observe(main, {childList:true, subtree:true});
    });
    return true;
  }
  function boot(){ if (!mount()) setTimeout(mount, 600); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
